import { render, staticRenderFns } from "./CommonAlert.vue?vue&type=template&id=55fc0e28&"
import script from "./CommonAlert.vue?vue&type=script&lang=js&"
export * from "./CommonAlert.vue?vue&type=script&lang=js&"
import style0 from "./CommonAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports